import { getClient } from '@/lib/restClient';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { Quantity } from '@/services/BrandOptionGroup';
import {
  BrandOptionGroupDelivery,
  BrandOptionGroupEatIn,
  BrandOptionGroupTakeout,
} from '@/services/BrandOptionGroup/hooks';
import { MenuManagementBrandOptionGroupService } from '@/services/BrandOptionGroup/MenuManagementOptionGroupService';

export type MenuManagementBrandOptionGroupUpdateParams = {
  associate_brand_id: number;
  title: Title;
  memo: string | null;
  takeout: BrandOptionGroupTakeout | null;
  eat_in: BrandOptionGroupEatIn | null;
  delivery: BrandOptionGroupDelivery | null;
  brand_item_sort_objects: SearchItem[];
  quantity: Quantity;
};

export const useMenuManagementUpdateBrandOptionGroup = async (
  id: string,
  params: MenuManagementBrandOptionGroupUpdateParams
): Promise<void> => {
  const menuManagementBrandOptionGroupService =
    new MenuManagementBrandOptionGroupService(getClient());

  return menuManagementBrandOptionGroupService.update(id, params);
};
